import { routes } from './base/apiRoutes';
import { deleteAPIResponse, getAPIResponse, postAPIResponse, putAPIResponse } from './base/api';
import queryString from 'query-string';

const clientId = import.meta.env.VITE_CLIENT_ID;
const clientSecret = import.meta.env.VITE_CLIENT_SECRET;
const redirectUrl = import.meta.env.VITE_REDIRECT_URL;

const handle401 = e => {
  if (e.response && e.response.status === 401) {
    // if (e.response && [401, 403].includes(e.response.status)) {
    localStorage.setItem('Authorization', '');
    window.location = window.origin;
  }

  return e;
};

export const generateAuthUrl = async data => {
  return postAPIResponse(routes.auth.auth_url, {
    ...data,
    clientId,
    clientSecret,
    redirectUrl,
  }).catch(e => {
    return handle401(e);
  });
};

export const getTokens = async (params = {}) => {
  const query = queryString.stringify(params);

  const url = `${routes.auth.get_tokens}?${query}`;
  return getAPIResponse(url);
};

export const logOut = async () => {
  return await getAPIResponse(routes.auth.logout, {}).catch(err => console.warn('Server logout failed:', err));
};

export const verifyTokenAndGetUser = async () => {
  return await getAPIResponse(`${routes.auth.verify_token}?clientId=${clientId}`).catch(err =>
    console.error('Failed to verify token', err)
  );
};

export const addUser = async ({ fullname, client_role, phone_number }) => {
  return await postAPIResponse(routes.user.add_user, {
    fullname,
    client_role,
    phone_number,
    profile_pic: null,
    client_id: clientId,
  }).catch(e => {
    return handle401(e);
  });
};

export const getUsers = async (params = {}) => {
  const query = queryString.stringify(params);
  return await getAPIResponse(`${routes.user.get_users}?${query}`).catch(e => {
    return handle401(e);
  });
};

// export const createProject = async data => {
//   return postAPIResponse(routes.projects, data).catch(e => {
//     return handle401(e);
//   });
// };

// export const getProjects = async (params = {}) => {
//   const query = queryString.stringify(params);
//   const url = query ? `${routes.projects}?${query}` : routes.projects;
//   return getAPIResponse(url).catch(e => {
//     return handle401(e);
//   });
// };

// export const getProjectById = async id => {
//   return getAPIResponse(`${routes.projects}/${id}`).catch(e => {
//     return handle401(e);
//   });
// };

// export const updateProject = async (id, data) => {
//   return putAPIResponse(`${routes.projects}/${id}`, data).catch(e => {
//     return handle401(e);
//   });
// };

// export const deleteProject = async id => {
//   return deleteAPIResponse(`${routes.projects}/${id}`).catch(e => {
//     return handle401(e);
//   });
// };
